import { createFileRoute } from '@tanstack/react-router'
import { requireModule, requirePermission } from '../../app/guards'
import { ProjectProfitabilityPage } from '../../features/reports/project-profitability-page'
import { profitabilitySearchSchema } from '../../features/reports/project-reports-search'

export const Route = createFileRoute('/_app/project-profitability')({
  staticData: { crumb: 'projectProfitability' },
  validateSearch: profitabilitySearchSchema,
  beforeLoad: ({ context }) => {
    requireModule(context.session, 'projects')
    requirePermission(context.session, 'projects.reports')
  },
  component: ProjectProfitabilityPage,
})
